module.exports = __webpack_public_path__ + "static/media/sakaneMabroukEV.67159b99.jpg";